var React = require('react');

function CloseSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7.5 6.44l4.5 4.5 4.5-4.5 1.06 1.06-4.5 4.5 4.5 4.5-1.06 1.06-4.5-4.5-4.5 4.5-1.06-1.06 4.5-4.5-4.5-4.5"}));
}

CloseSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CloseSmall;

CloseSmall.default = CloseSmall;
